import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatINR = (value) => {
  if (value == null || isNaN(value)) return '\u20B90';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

export const EXPENSE_CATEGORIES = [
  'Maintenance', 'Cleaning', 'Staff Salaries', 'Utilities', 'Insurance', 'Property Tax',
  'Mortgage/EMI', 'Furnishing', 'Marketing', 'Platform Fees', 'Legal',
  'Supplies', 'Repairs', 'Other'
];

export const PROPERTY_TYPES = [
  // Residential  Short-term rental
  'Apartment', 'Villa', 'House', 'Studio', 'Penthouse', 'Cottage', 'Farmhouse',
  // Residential  Long-term rental / lease
  'Long-term Rental', 'Lease Property', 'PG / Hostel', 'Co-living Space',
  // Shared / unique
  'Shared Room', 'Private Room', 'Guest House', 'Service Apartment',
  // Commercial
  'Commercial Space', 'Office Space', 'Shop / Retail', 'Warehouse',
  'Co-working Space', 'Industrial Property',
  // Land / plots
  'Residential Plot', 'Commercial Plot', 'Agricultural Land',
  // Other
  'Resort / Hotel Room', 'Houseboat', 'Treehouse', 'Glamping / Tent', 'Other',
];

export const AMENITIES_LIST = [
  // Essentials
  'WiFi', 'AC', 'Heating', 'Kitchen', 'Parking', 'TV', 'Washing Machine',
  'Hot Water', 'Power Backup',
  // Outdoor / building
  'Pool', 'Gym', 'Balcony', 'Garden', 'Terrace', 'Security', 'Elevator',
  'CCTV', 'Intercom', 'Gated Society',
  // Comfort
  'Furnished', 'Semi-Furnished', 'Modular Kitchen', 'Work Desk',
  // Guest-friendly
  'Pet Friendly', 'Wheelchair Accessible', 'EV Charging',
  // Commercial / co-working
  'Conference Room', 'High-Speed Internet', 'Pantry',
];

export const PLATFORMS = ['Airbnb', 'Booking.com', 'MakeMyTrip', 'OYO', 'Direct Booking', 'Other'];

export const INDIA_CITIES = {
  "Goa":               ["Panaji", "Calangute", "Baga", "Anjuna", "Vagator", "Morjim", "Arambol", "Palolem", "Colva", "Margao", "Mapusa", "Vasco da Gama", "Candolim", "Assagao"],
  "Maharashtra":       ["Mumbai", "Pune", "Nashik", "Aurangabad", "Nagpur", "Lonavala", "Mahabaleshwar", "Alibaug", "Kolad", "Matheran", "Panchgani"],
  "Karnataka":         ["Bengaluru", "Mysuru", "Coorg", "Hampi", "Chikmagalur", "Sakleshpur", "Dandeli", "Gokarna", "Udupi", "Mangaluru", "Badami"],
  "Rajasthan":         ["Jaipur", "Udaipur", "Jodhpur", "Jaisalmer", "Pushkar", "Ranthambore", "Bikaner", "Ajmer", "Bundi", "Kota", "Shekhawati"],
  "Kerala":            ["Kochi", "Thiruvananthapuram", "Munnar", "Alleppey", "Kovalam", "Varkala", "Kozhikode", "Thrissur", "Kannur", "Wayanad", "Kumarakom"],
  "Tamil Nadu":        ["Chennai", "Coimbatore", "Ooty", "Kodaikanal", "Madurai", "Trichy", "Pondicherry", "Vellore", "Salem", "Thanjavur", "Rameshwaram", "Kanyakumari"],
  "Telangana":         ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
  "Andhra Pradesh":    ["Visakhapatnam", "Vijayawada", "Tirupati", "Amaravati", "Araku Valley"],
  "Delhi":             ["New Delhi", "Delhi"],
  "Uttar Pradesh":     ["Agra", "Varanasi", "Lucknow", "Mathura", "Vrindavan", "Allahabad", "Noida", "Ghaziabad"],
  "Himachal Pradesh":  ["Manali", "Shimla", "Kasol", "Dharamshala", "McLeod Ganj", "Dalhousie", "Bir Billing", "Spiti", "Kullu", "Kufri"],
  "Uttarakhand":       ["Rishikesh", "Haridwar", "Mussoorie", "Nainital", "Auli", "Jim Corbett", "Lansdowne", "Chopta", "Chakrata", "Tehri"],
  "Jammu & Kashmir":   ["Srinagar", "Gulmarg", "Pahalgam", "Sonamarg", "Leh", "Jammu"],
  "Ladakh":            ["Leh", "Nubra Valley", "Pangong", "Zanskar"],
  "West Bengal":       ["Kolkata", "Darjeeling", "Kalimpong", "Sundarbans", "Digha", "Siliguri"],
  "Odisha":            ["Bhubaneswar", "Puri", "Konark", "Chilika"],
  "Gujarat":           ["Ahmedabad", "Surat", "Vadodara", "Rann of Kutch", "Dwarka", "Somnath", "Gir"],
  "Madhya Pradesh":    ["Bhopal", "Indore", "Jabalpur", "Khajuraho", "Orchha", "Pachmarhi", "Kanha", "Bandhavgarh"],
  "Assam":             ["Guwahati", "Kaziranga", "Majuli", "Tezpur", "Dibrugarh"],
  "Meghalaya":         ["Shillong", "Cherrapunji", "Dawki", "Mawlynnong"],
  "Sikkim":            ["Gangtok", "Pelling", "Lachung", "Yuksom"],
  "Arunachal Pradesh": ["Tawang", "Ziro", "Itanagar", "Bomdila"],
  "Other":             ["Other"],
};


// Mirrors the backend's _perm_level: owners always "edit"; staff get what the host granted.
// The server is still the authority (every mutation re-checks); this only decides whether
// to render a control the user would be refused for.
export function permLevel(user, page) {
  if (!user?.is_staff) return "edit";
  const perms = user.permissions || {};
  if (Array.isArray(perms)) return perms.includes(page) ? "edit" : "none";
  return perms[page] || "none";
}

export const canEdit = (user, page) => permLevel(user, page) === "edit";
